import ResourceManager from "@/components/admin/ResourceManager";
import { Field, ImageUploader, TextArea, Toggle } from "@/components/admin/Primitives";

export default function Blogs() {
  return (
    <ResourceManager
      resource="blogs"
      title="Blog & News"
      subtitle="Tournament recaps, tips, announcements."
      defaults={{ title: "", slug: "", excerpt: "", content: "", category: "News", cover_image: "", is_published: true }}
      columns={[
        { key: "cover_image", label: "Cover" },
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "is_published", label: "Published" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="Title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} required testid="blog-title" />
          <Field label="Slug (auto if empty)" value={form.slug} onChange={(v) => setForm({ ...form, slug: v })} testid="blog-slug" />
          <Field label="Category" value={form.category} onChange={(v) => setForm({ ...form, category: v })} testid="blog-category" />
          <TextArea label="Excerpt" rows={3} value={form.excerpt} onChange={(v) => setForm({ ...form, excerpt: v })} required testid="blog-excerpt" />
          <TextArea label="Content (HTML allowed)" rows={10} value={form.content} onChange={(v) => setForm({ ...form, content: v })} required testid="blog-content" />
          <ImageUploader value={form.cover_image} onChange={(v) => setForm({ ...form, cover_image: v })} testid="blog-cover" />
          <Toggle label="Published" checked={form.is_published} onChange={(v) => setForm({ ...form, is_published: v })} testid="blog-published" />
        </>
      )}
    />
  );
}
